// LayoutAlerts.tsx
import { useEffect, useState } from 'react';
import { Alert, AlertTitle, Stack } from '@mui/material';
import { layoutAlertManager } from './alert';
import { AlertCloseTimerButton } from './AlertCloseTimerButton';
import type { AlertItem } from './alert';

export const LayoutAlerts = () => {
  const [alerts, setAlerts] = useState<AlertItem[]>([]);
  useEffect(() => {
    const unsubscribe = layoutAlertManager.subscribe((mes) => {
      setAlerts(mes);
    });
    return () => unsubscribe();
  }, []);

  const handleClose = (alert:AlertItem) => {
    layoutAlertManager.closeLayoutAlert(alert.id);
    alert.onClose && alert.onClose();
  };
  return (
    <Stack spacing={1} gap={0} zIndex={9999}>
      {alerts.map((alert) => (
        <Alert
          key={alert.id}
          severity={alert.type}
          onClose={() => layoutAlertManager.closeLayoutAlert(alert.id)}
          sx={{ borderRadius: 3, minWidth: 300 }}
          action={<AlertCloseTimerButton onClick={handleClose} cx={alert} delay={alert.delay} />}
        >
          <AlertTitle sx={{ fontWeight: 600, fontSize: '12px' }}>{alert.title || 'Alert'}</AlertTitle>
          <span style={{ fontSize: '11px' }}>{alert.message}</span>
        </Alert>
      ))}
    </Stack>
  );
};
